import { Link } from 'react-router-dom'
import styled from 'styled-components'
import {Pagination} from 'antd'
// import cn from 'clsx'
import styles from './List.module.scss'
import { Box, Block, Text, Empty, SearchIcon, } from 'common/components'

const ItemContainer = styled.div<any>`
  padding: 1rem;
  width: 100%;
  /* border: 3px solid red; */
  display: grid;
  grid-template-columns: ${props => `repeat(${props.n},1fr)`};
  background-color: ${props => !!props.selected ? `hsl(30, 60%, 80%)`:''};
  cursor: ${props => !!props.onClick ? `pointer`:''};
`

interface ItemProps {
  [propName:string]: any;
}
interface ListProps {
  keys: string[];
  items: ItemProps[];
  selectedItemsId?: string[];
  linkToPrefix?: string;
  onItemClick?: (id: string) => void;
  page?: number;
  total?: number;
  setPage?: (page: number) => void;
}
interface ListItemProps {
  keys: string[];
  item: ItemProps;
  linkToPrefix?: string;
  selected?: boolean;
  onItemClick?: (id: string) => void;
}

const PAGE_SIZE = 10
export const List: React.FC<ListProps> = ({ onItemClick, selectedItemsId, linkToPrefix, keys, items, page, total, setPage, }) => {
  const pageItems = (page === undefined) ? items : ( items?.filter(
    (_:any, index: number) => ((index >= ((page-1) * PAGE_SIZE)) && ((index < ((page) * PAGE_SIZE))))
  ) || [] )
  return (
    !pageItems.length ? 
    <Empty
      icon={<SearchIcon width={40} height={40} />}
      title="search results"
    />
    :
    <>
      <ul>
        {pageItems.map((item, index:number) => (
          <ListItem key={index} 
            selected={selectedItemsId?.includes(item.id)}
            keys={keys} 
            item={item} 
            linkToPrefix={linkToPrefix} 
            onItemClick={onItemClick}
          />
        ))}
      </ul>
      { !!setPage &&
        <Pagination
          showSizeChanger={false}
          current={page}
          total={total}
          pageSize={10}
          onChange={setPage}
        />
      }
    </>
  )
}

const ConditionLink = ({to, children}:any) => (
  !to ?
  <> { children} </>
  :
  <Link to={to}>{ children }</Link>
)

const ListItem: React.FC<ListItemProps> = ({onItemClick, selected, linkToPrefix, keys, item}) => {
  return (
    <Block as="li" className={styles.full}>
      <ItemContainer n={keys.length} selected={selected} onClick={!!onItemClick ? () => onItemClick(item.id) : undefined}>
      { keys.map((k:string) => (
        <ConditionLink key={k} to={!linkToPrefix ? null : `${linkToPrefix}/${item.id}`}>
          <Box>
            <Text weight="demiBold">
              { !!item[k] ? `${item[k]}` : ''}
            </Text>
          </Box>
        </ConditionLink>
      )) }
      </ItemContainer>
    </Block>
  )
}
